/* eslint-disable no-unused-expressions */

import { useState } from "react";
import {
  dangerMessage,
  successMessage,
  warningMessage,
} from "../components/Toast";

const usePost = () => {
  const [postData, updatePostData] = useState({
    pending: false,
    data: undefined,
    data2: undefined,
    error: undefined,
    lengths: undefined,
    status: null,
  });

  const execute = async (
    endPoint,
    raw,
    Method,
    displayMessage,
    token,
    isJSON
  ) => {
    updatePostData({
      pending: true,
      data: undefined,
      data2: undefined,
      error: undefined,
      lengths: undefined,
      status: null,
    });

    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    isJSON ? null : myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: Method,
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    // http://localhost:4800
    //https://gh.prop.faspro24.com
    // gh.prop.faspro24.com

    return fetch(
      `https://gh.prop.faspro24.com/api/v1/${endPoint}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((res) => {
        if (res?.status === "success") {
          updatePostData({
            pending: false,
            data: res,
            data2: res,
            error: undefined,
            lengths: res.result,
            status: res?.status,
          });
          displayMessage === true ? null : successMessage(`${displayMessage}`);
        }
        if (res?.status === "fail") {
          updatePostData({
            pending: false,
            data: undefined,
            data2: undefined,
            error: res?.message,
            lengths: undefined,
            status: res?.status,
          });
          warningMessage(`${res?.message}`);
        }
        if (res?.status === "error") {
          updatePostData({
            pending: false,
            data: undefined,
            data2: undefined,
            error: res?.message,
            lengths: undefined,
          });
          if (res?.message === "jwt malformed") {
            warningMessage("You need to login");
          } else {
            warningMessage("Network issue please try again");
          }
        }
      })
      .catch((error) => {
        updatePostData({
          pending: false,
          data: undefined,
          data2: undefined,
          error: error.message,
          lengths: undefined,
        });
        dangerMessage(`${error.message}`);
      });
  };

  return {
    execute,
    pending: postData.pending,
    data: postData.data,
    data2: postData.data,
    status: postData.status,
    error: postData.error,
    lengths: postData.lengths,
  };
};

export default usePost;
